import { useQuery } from "@tanstack/react-query";
import { HelpService } from "@/services/HelpService";

const helpService = new HelpService();

/**
 * Hook to fetch all help categories
 * Stale time: 30 minutes (categories rarely change)
 */
export const useHelpCategories = () => {
  return useQuery({
    queryKey: ["help", "categories"],
    queryFn: () => helpService.getCategories(),
    staleTime: 1000 * 60 * 30, // 30 minutes
  });
};

/**
 * Hook to fetch a category with its articles by slug
 * Stale time: 15 minutes
 */
export const useHelpCategory = (slug: string) => {
  return useQuery({
    queryKey: ["help", "category", slug],
    queryFn: () => helpService.getCategoryWithArticles(slug),
    enabled: !!slug,
    staleTime: 1000 * 60 * 15, // 15 minutes
  });
};

/**
 * Hook to fetch an article by slug
 * Stale time: 15 minutes
 */
export const useHelpArticle = (slug: string) => {
  return useQuery({
    queryKey: ["help", "article", slug],
    queryFn: () => helpService.getArticle(slug),
    enabled: !!slug,
    staleTime: 1000 * 60 * 15, // 15 minutes
  });
};

/**
 * Hook to search help content
 * Only enabled when query is at least 2 characters
 * Stale time: 5 minutes
 */
export const useHelpSearch = (query: string) => {
  return useQuery({
    queryKey: ["help", "search", query],
    queryFn: () => helpService.search(query),
    enabled: query.trim().length >= 2,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};

/**
 * Hook to fetch all FAQs
 * Stale time: 30 minutes
 */
export const useHelpFAQs = () => {
  return useQuery({
    queryKey: ["help", "faqs"],
    queryFn: () => helpService.getFAQs(),
    staleTime: 1000 * 60 * 30, // 30 minutes
  });
};
